// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__8uzJV","container":"DefaultLayout_container__WA-zN","content":"DefaultLayout_content__Jste6"};